import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import T from 'i18n-react';
import TextField from '@material-ui/core/TextField';
import { actAnyFieldUpdate, getValue } from 'actions/formActions';
import { connect } from 'react-redux';
import { formatDate } from '../util/icwUtility';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    '& label, input': {
      paddingLeft: '10px',
      paddingRight: '10px',
    },
  },
  textField: {
    width: '100%',
    marginTop: '10px',
  },
  labelDiv: {
    display: 'flex',
  },
  mandatory: {
    fontSize: '20px',
    color: 'red',
    marginRight: '10px',
  },
});

function DatePicker(props) {
  const {
    classes,
    onFieldUpdate,
    storeName,
    accessPath,
    onChange,
    newAccessPath,
    error,
    fieldName,
    noLabel,
    mandatory,
    placeholder,
    shrink,
    disabled, // for withStatus
  } = props;
  function myUpdateFunc(e) {
    if (onChange) {
      onChange(e.target.value);
    }
    if (newAccessPath) {
      onFieldUpdate(storeName, newAccessPath, e.target.value);
    }
    onFieldUpdate(storeName, accessPath, e.target.value);
  }

  function myValue() {
    const v = getValue(props[storeName].data, accessPath);
    return v;
  }

  const getPlaceholder = () => {
    let text = '';

    if (placeholder) {
      text = placeholder;
    } else {
      text = T.translate(`${storeName}.${accessPath[accessPath.length - 1]}`);
    }
    return text;
  };

  return (
    <TextField
      id='date'
      label={
        !noLabel ? (
          typeof accessPath[accessPath.length - 1] === 'string' ? (
            <div className={classes.labelDiv}>
              {mandatory ? <div className={classes.mandatory}>*</div> : null}
              {T.translate(`${storeName}.${accessPath[accessPath.length - 1]}`)}
            </div>
          ) : (
            <div className={classes.labelDiv}>
              {mandatory ? <div className={classes.mandatory}>*</div> : null}
              {T.translate(`${storeName}.${fieldName}`)}
            </div>
          )
        ) : null
      }
      type='date'
      disabled={disabled}
      className={classes.textField}
      value={myValue() && myValue() !== null && myValue() !== 'NULL' ? formatDate(myValue()) : ''}
      onChange={(e) => {
        onChange && onChange(e);
        myUpdateFunc(e);
      }}
      InputLabelProps={{ shrink }}
      placeholder={getPlaceholder()}
      error={error != null}
    />
  );
}

DatePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  storeName: PropTypes.string.isRequired,
  accessPath: PropTypes.array,
};

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => ({
  onFieldUpdate: (storeName, accessPath, newVal) => {
    dispatch(actAnyFieldUpdate(storeName, accessPath, newVal));
  },
});

const DatePickerContainer = connect(mapStateToProps, mapDispatchToProps)(DatePicker);

export default withStyles(styles)(DatePickerContainer);
